import { useMemo } from 'react';

import { Roles } from '@/common/constants';
import { useHasAccess } from '@/modules/core/hooks';
import useOrganizationViewDataQuery from '@/modules/user/queries/useOrganizationViewData.query';
import { useAuthStore } from '@/modules/user/stores';

const useCanEditAddress = () => {
  const { user } = useAuthStore();
  const organizationId = user?.organization?.id;
  const { formattedData } = useOrganizationViewDataQuery(organizationId);

  const isLimitedAccess = useHasAccess([{ role: Roles.employeeLimitedAccess }]);

  const isAddressEditingAllowed = !!formattedData?.allowEmployeeToEditAddress;

  const statementType = formattedData?.statementType;

  const canEdit = useMemo(
    () => !isLimitedAccess && isAddressEditingAllowed,
    [isLimitedAccess, isAddressEditingAllowed]
  );

  return { canEdit, isLimitedAccess, isAddressEditingAllowed, statementType };
};

export default useCanEditAddress;
